import { forwardRef, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Map only navigation, never API URLs or IDs. Legacy and job entry points retain
// their existing routes; pages entered through the workspace stay in it.
const ROUTES = [
  ["/app/safety/site-inductions", "/app/health-safety/inductions"],
  ["/app/safety/hazardous-substances", "/app/health-safety/hazsub"],
  ["/app/sssps", "/app/health-safety/sssps"],
  ["/app/toolbox", "/app/health-safety/toolbox-talks"],
  ["/app/prestarts", "/app/health-safety/pre-starts"],
  ["/app/inspections", "/app/health-safety/inspections"],
  ["/app/qa", "/app/health-safety/qa"],
  ["/app/forms", "/app/health-safety/forms"],
  ["/app/safety", "/app/health-safety/hazards"],
];
export function safetyWorkspacePath(to, pathname) {
  if (!(pathname === "/app/health-safety" || pathname.startsWith("/app/health-safety/"))) return to;
  if (to && typeof to === "object") return { ...to, pathname: safetyWorkspacePath(to.pathname || "", pathname) };
  if (typeof to !== "string") return to;
  const pair = ROUTES.find(([from]) => to === from || ["/", "?", "#"].some((sep) => to.startsWith(from + sep)));
  return pair ? pair[1] + to.slice(pair[0].length) : to;
}
export function useSafetyNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback((to, options) => navigate(safetyWorkspacePath(to, pathname), options), [navigate, pathname]);
}
export const SafetyLink = forwardRef(function SafetyLink({ to, ...props }, ref) {
  const { pathname } = useLocation();
  return <Link ref={ref} to={safetyWorkspacePath(to, pathname)} {...props} />;
});
